/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

/**
 * One item the palette could open or act on.
 */
export type LauncherCandidate = {
  /**
   * Short state description, such as 'MCP server · disabled'.
   */
  detail?: string | undefined;
  /**
   * Caller-chosen stable identifier echoed back in the judgment.
   */
  id: string;
  /**
   * The candidate kind, such as page, mcp_server, plugin or marketplace.
   */
  kind: string;
  /**
   * Display title of the candidate.
   */
  title: string;
  /**
   * Verbs the caller may run on this candidate, such as open, enable, disable or publish.
   */
  verbs?: Array<string> | undefined;
};

/** @internal */
export type LauncherCandidate$Outbound = {
  detail?: string | undefined;
  id: string;
  kind: string;
  title: string;
  verbs?: Array<string> | undefined;
};

/** @internal */
export const LauncherCandidate$outboundSchema: z.ZodMiniType<
  LauncherCandidate$Outbound,
  LauncherCandidate
> = z.object({
  detail: z.optional(z.string()),
  id: z.string(),
  kind: z.string(),
  title: z.string(),
  verbs: z.optional(z.array(z.string())),
});

export function launcherCandidateToJSON(
  launcherCandidate: LauncherCandidate,
): string {
  return JSON.stringify(
    LauncherCandidate$outboundSchema.parse(launcherCandidate),
  );
}
